/**
 * Códigos de error que devuelve la API en `{ error: { code, message } }`.
 * La web los usa para reaccionar a casos concretos (p. ej. ubicación ocupada).
 */
export const ERROR_CODES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',

  PALLET_NOT_FOUND: 'PALLET_NOT_FOUND',
  PALLET_NOT_IN_STOCK: 'PALLET_NOT_IN_STOCK',
  PALLET_INVALID_STATUS: 'PALLET_INVALID_STATUS',
  PALLET_ALREADY_IN_LOCATION: 'PALLET_ALREADY_IN_LOCATION',
  LOCATION_NOT_FOUND: 'LOCATION_NOT_FOUND',
  LOCATION_OCCUPIED: 'LOCATION_OCCUPIED',
  LOCATION_OUT_OF_SERVICE: 'LOCATION_OUT_OF_SERVICE',
  LOCATION_IN_USE: 'LOCATION_IN_USE',
  INACTIVE_CLIENT: 'INACTIVE_CLIENT',
  INACTIVE_PRODUCT: 'INACTIVE_PRODUCT',
  OUTBOUND_INVALID_STATE: 'OUTBOUND_INVALID_STATE',
  OUTBOUND_PALLET_NOT_IN_ORDER: 'OUTBOUND_PALLET_NOT_IN_ORDER',
  PALLET_ALREADY_RESERVED: 'PALLET_ALREADY_RESERVED',
  RATE_NOT_FOUND: 'RATE_NOT_FOUND',
  RATE_OVERLAP: 'RATE_OVERLAP',
  INVOICE_INVALID_STATE: 'INVOICE_INVALID_STATE',
  INVOICE_NOTHING_TO_BILL: 'INVOICE_NOTHING_TO_BILL',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export interface ApiErrorBody {
  error: {
    code: ErrorCode;
    message: string;
    /** Errores por campo (validación). */
    fields?: Record<string, string>;
  };
}
